<div class="bitcoin-app investments-popup"
     [class.is-active]="activeClass">
  <div class="bitcoin-app__inner investments-popup__inner">
    <button class="investments-popup__close"
            (click)="handleClose()"></button>
    <iframe [src]="safeUrl" allow="clipboard-write *; clipboard-read *"></iframe>
  </div>
</div>
